// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * TrackpadScrollEmulator
 * Author: Jonathan Nicol @f6design
 * https://github.com/jnicol/trackpad-scroll-emulator
 */
 
 .tse-scrollable {
  position: relative;
  width: 200px; /* Default value. Overwite this if you want. */
  height: 300px; /* Default value. Overwite this if you want. */
  overflow: hidden;
  }
  .tse-scrollable .tse-scroll-content {
    overflow: hidden;
    overflow-y: scroll;
    }
    /* No longer using ::scrollbar too, since it breaks Chrome 25 */
    .tse-scrollable .tse-scroll-content::-webkit-scrollbar {
      width: 0;
      height: 0;
      }
.tse-scrollbar {
  z-index: 99;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 11px;
  }
  .tse-scrollbar .drag-handle {
    position: absolute;
    right: 2px;
    -webkit-border-radius: 7px;
    -moz-border-radius: 7px;
    border-radius: 7px;
    min-height: 10px;
    width: 7px;
    opacity: 0;
    -webkit-transition: opacity 0.2s linear;
    -moz-transition: opacity 0.2s linear;
    -o-transition: opacity 0.2s linear;
    -ms-transition: opacity 0.2s linear;
    transition: opacity 0.2s linear;
    background: #6c6e71;
    -webkit-background-clip: padding-box;
    -moz-background-clip: padding;
    }
  .tse-scrollbar:hover .drag-handle {
    /* When hovered, remove all transitions from drag handle */
    opacity: 0.7;
    -webkit-transition: opacity 0 linear;
    -moz-transition: opacity 0 linear;
    -o-transition: opacity 0 linear;
    -ms-transition: opacity 0 linear;
    transition: opacity 0 linear;
    }
    .tse-scrollbar .drag-handle.visible {
      opacity: 0.7;
      }
/* Used when testing the scrollbar width */
/* No longer using ::scrollbar too, since it breaks Chrome 25 */
.scrollbar-width-tester::-webkit-scrollbar {
  width: 0;
  height: 0;
}
/* Horizontal scroller */
.tse-scrollable.horizontal .tse-scroll-content {
  overflow-x: scroll;
  overflow-y: hidden;
  }
  .tse-scrollable.horizontal .tse-scroll-content::-webkit-scrollbar,
  .tse-scrollable.horizontal .tse-scroll-content::scrollbar {
    width: auto;
    height: 0;
    }
.tse-scrollable.horizontal .tse-scrollbar {
  top: auto;
  left: 0;
  width: auto;
  height: 11px;
  }
  .tse-scrollable.horizontal .tse-scrollbar .drag-handle {
    right: auto;
    top: 2px;
    height: 7px;
    min-height: 0;
    min-width: 10px;
    width: auto;
    }
`, "",{"version":3,"sources":["webpack://./node_modules/trackpad-scroll-emulator/css/trackpad-scroll-emulator.css"],"names":[],"mappings":"AAAA;;;;EAIE;;CAED;EACC,kBAAkB;EAClB,YAAY,EAAE,8CAA8C;EAC5D,aAAa,EAAE,8CAA8C;EAC7D,gBAAgB;EAChB;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB;IACA,+DAA+D;IAC/D;MACE,QAAQ;MACR,SAAS;MACT;AACN;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,WAAW;EACX;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,0BAA0B;IAC1B,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,UAAU;IACV,uCAAuC;IACvC,oCAAoC;IACpC,kCAAkC;IAClC,mCAAmC;IACnC,+BAA+B;IAC/B,mBAAmB;IACnB,oCAAoC;IACpC,6BAA6B;IAC7B;EACF;IACE,0DAA0D;IAC1D,YAAY;IACZ,oCAAoC;IACpC,iCAAiC;IACjC,+BAA+B;IAC/B,gCAAgC;IAChC,4BAA4B;IAC5B;IACA;MACE,YAAY;MACZ;AACN,0CAA0C;AAC1C,+DAA+D;AAC/D;EACE,QAAQ;EACR,SAAS;AACX;AACA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,kBAAkB;EAClB;EACA;;IAEE,WAAW;IACX,SAAS;IACT;AACJ;EACE,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ;EACA;IACE,WAAW;IACX,QAAQ;IACR,WAAW;IACX,aAAa;IACb,eAAe;IACf,WAAW;IACX","sourcesContent":["/**\n * TrackpadScrollEmulator\n * Author: Jonathan Nicol @f6design\n * https://github.com/jnicol/trackpad-scroll-emulator\n */\n \n .tse-scrollable {\n  position: relative;\n  width: 200px; /* Default value. Overwite this if you want. */\n  height: 300px; /* Default value. Overwite this if you want. */\n  overflow: hidden;\n  }\n  .tse-scrollable .tse-scroll-content {\n    overflow: hidden;\n    overflow-y: scroll;\n    }\n    /* No longer using ::scrollbar too, since it breaks Chrome 25 */\n    .tse-scrollable .tse-scroll-content::-webkit-scrollbar {\n      width: 0;\n      height: 0;\n      }\n.tse-scrollbar {\n  z-index: 99;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 11px;\n  }\n  .tse-scrollbar .drag-handle {\n    position: absolute;\n    right: 2px;\n    -webkit-border-radius: 7px;\n    -moz-border-radius: 7px;\n    border-radius: 7px;\n    min-height: 10px;\n    width: 7px;\n    opacity: 0;\n    -webkit-transition: opacity 0.2s linear;\n    -moz-transition: opacity 0.2s linear;\n    -o-transition: opacity 0.2s linear;\n    -ms-transition: opacity 0.2s linear;\n    transition: opacity 0.2s linear;\n    background: #6c6e71;\n    -webkit-background-clip: padding-box;\n    -moz-background-clip: padding;\n    }\n  .tse-scrollbar:hover .drag-handle {\n    /* When hovered, remove all transitions from drag handle */\n    opacity: 0.7;\n    -webkit-transition: opacity 0 linear;\n    -moz-transition: opacity 0 linear;\n    -o-transition: opacity 0 linear;\n    -ms-transition: opacity 0 linear;\n    transition: opacity 0 linear;\n    }\n    .tse-scrollbar .drag-handle.visible {\n      opacity: 0.7;\n      }\n/* Used when testing the scrollbar width */\n/* No longer using ::scrollbar too, since it breaks Chrome 25 */\n.scrollbar-width-tester::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n/* Horizontal scroller */\n.tse-scrollable.horizontal .tse-scroll-content {\n  overflow-x: scroll;\n  overflow-y: hidden;\n  }\n  .tse-scrollable.horizontal .tse-scroll-content::-webkit-scrollbar,\n  .tse-scrollable.horizontal .tse-scroll-content::scrollbar {\n    width: auto;\n    height: 0;\n    }\n.tse-scrollable.horizontal .tse-scrollbar {\n  top: auto;\n  left: 0;\n  width: auto;\n  height: 11px;\n  }\n  .tse-scrollable.horizontal .tse-scrollbar .drag-handle {\n    right: auto;\n    top: 2px;\n    height: 7px;\n    min-height: 0;\n    min-width: 10px;\n    width: auto;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
